module.exports = __webpack_public_path__ + "static/media/photo241.cfc6571b.jpg";